// Unpublished Work © 2025 Deere & Company.

import {
    commonErrorAction,
    ErrorHandlerConfig,
} from '../App/utils/errorMessages';

export const predictiveFeedRateError: ErrorHandlerConfig = {
    customAction: (error, query) => commonErrorAction(error, query),
};

export const predictiveFeedRateOrgPreferencesError: ErrorHandlerConfig = {
    customAction: (error, query) => commonErrorAction(error, query),
};
